import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { cardStyles } from '../../styles/card';

@customElement('umb-market-skeleton-card')
export class UmbMarketSkeletonCard extends LitElement {
  @property({ type: String })
  bones!: string;

  render() {
    return html`
      <div class="card ${this.bones}">
        <div class="card-body">
          <div class="dinkus">
            <div class="image-wrapper">
              <bones w h style="border-radius:var(--xs-spacer)"></bones>
            </div>
            <bones w style="--bone-height:34px"></bones>
          </div>

          <bones style="margin-top:16px;"></bones>
          <bones style="margin-top:6px;"></bones>
          <bones style="margin-top:6px;"></bones>

          <div class="card-footer" style="margin-top:18px">
            <bones
              style="width:18ch; --bone-height:32px; border-radius:var(--s-spacer)"
            ></bones>
          </div>
        </div>
      </div>
    `;
  }

  static styles = [
    cardStyles,
    css`
      .card,
      .card-header,
      .card:hover,
      .card:hover .card-header {
        border-color: #ddd;
        pointer-events: none;
      }

      bones {
        background: #ebebeb;
        display: block;
        min-height: var(--bone-height, 24px);
        position: relative;
        overflow: hidden;
      }

      bones::before {
        content: '';
        position: absolute;
        inset: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.125) 20%,
          rgba(255, 255, 255, 0.25) 60%,
          transparent 100%
        );
        animation: shimmer 2s infinite;
      }

      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }

      [w] {
        width: 100%;
      }

      [h] {
        height: 100%;
      }

      .image-wrapper {
        padding: 0;
        background: transparent;
        flex: 1 0 auto;
      }
    `,
  ];
}
